import { render, staticRenderFns } from "./StoryTeaser.vue?vue&type=template&id=e8462278"
import script from "./StoryTeaser.vue?vue&type=script&lang=js"
export * from "./StoryTeaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports